module.exports = __webpack_public_path__ + "img/Ymanci_Logo_v2.c2df7450.svg";